var themeColors = ['#00467f', '#638d3d', '#c35627', '#a6bbca', '#007dc3', '#692f25', '#007dc3', '#e6c29f', '#5c8727', '#d1d5d8', '#b38807', '#d3d7ab', '#455560', '#d8b5a3', '#7a1501', '#b9c9d5', '#6fab47', '#e6e600'];

Highcharts.setOptions({
    colors: themeColors.map(function (color) {
        return {
            radialGradient: { cx: 0.5, cy: 0.3, r: 0.7 },
            stops: [
                [0, color]
            ]
        };
    }),
    chart: {
        zooming: {
            mouseWheel: { enabled: false }
        }
    },
    legend: {
        symbolRadius: 2
    }
});
